export default "__VITE_ASSET__Df$WD7kx__"